import { useState, useEffect } from "react";
import { Carousel1, affection, Carousel4 } from "../assets";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCircle } from "@fortawesome/free-solid-svg-icons";

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [
    {
      image: Carousel4,
      title: "Committed to Your Mental Wellness",
      subtitle: "Professional psychiatric care in the comfort of your home",
      cta: "Get Started",
      link: "/contact",
    },
    {
      image: affection,
      title: "Comprehensive Mental Health Services",
      subtitle: "Expert treatment for anxiety, depression, ADHD, and more",
      cta: "Explore Services",
      link: "/mainservicepage",
    },
    {
      image: Carousel1,
      title: "Convenient Telehealth Appointments",
      subtitle: "Quality care accessible from MD, DC, and VA",
      cta: "Learn More",
      link: "/aboutme",
    },
  ];

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 9000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative overflow-hidden max-w-full">
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div className="relative min-w-full" key={index}>
            <img
              src={slide.image}
              alt={`Slide ${index + 1}`}
              className="w-full h-[600px] md:h-[700px] lg:h-screen object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
                <div
                  className="max-w-2xl transform transition-all duration-1000 ease-out"
                  style={{
                    transform: `translateX(${
                      currentIndex === index ? "0" : "-100px"
                    })`,
                    opacity: `${currentIndex === index ? "1" : "0"}`,
                  }}
                >
                  <h1 className="text-display-sm md:text-display-md lg:text-display-lg text-white font-bold mb-6 leading-tight">
                    {slide.title}
                  </h1>
                  <p className="text-body-lg md:text-heading-sm text-white/90 mb-8 leading-relaxed">
                    {slide.subtitle}
                  </p>
                  <Link to={slide.link}>
                    <button className="group px-8 py-4 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-3">
                      {slide.cta}
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="transition-transform group-hover:translate-x-1"
                      />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className="group"
            aria-label={`Go to slide ${index + 1}`}
          >
            <FontAwesomeIcon
              icon={faCircle}
              className={`transition-all duration-300 ${
                currentIndex === index
                  ? "text-white text-sm"
                  : "text-white/50 text-xs group-hover:text-white/75"
              }`}
            />
          </button>
        ))}
      </div>

      <button
        onClick={handlePrev}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 z-10"
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button
        onClick={handleNext}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 z-10"
        aria-label="Next slide"
      >
        ›
      </button>
    </div>
  );
};

export default ImageSlider;
